(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-month-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cz-bf-banner')) {
    class CZBFMonthBanner extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.editor = this.dataset.editor === 'true';
        this.status = this.querySelector('[data-status]');
        this.note = this.querySelector('[data-editor-note]');
        this.selectedId = null;
        this.copyVersion = 0;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-copy-button]');
          if (button && this.contains(button)) this.copyCode(button);
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, options);
        window.addEventListener('pageshow', () => this.refresh(), options);
        if (this.editor) {
          document.addEventListener('shopify:block:select', event => {
            const panel = this.panels.find(item => item.dataset.panel === event.detail?.blockId);
            if (panel) { this.selectedId = panel.dataset.panel; this.refresh(); }
          }, options);
          document.addEventListener('shopify:block:deselect', event => {
            if (event.detail?.blockId === this.selectedId) { this.selectedId = null; this.refresh(); }
          }, options);
        }
        this.refresh();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        clearTimeout(this.scheduleTimer);
        clearTimeout(this.copyTimer);
        this.copyVersion++;
      }
      parseTime(value) {
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(value || '')) return NaN;
        const parts = value.slice(0, 19).split(/[-T:]/).map(Number);
        const [year, month, day, hour, minute, second] = parts;
        const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
        if (year < 2020 || month < 1 || month > 12 || day < 1 || day > days || hour > 23 || minute > 59 || second > 59) return NaN;
        return Date.parse(value);
      }
      period(panel) {
        const start = this.parseTime(panel.dataset.start);
        const end = this.parseTime(panel.dataset.end);
        return { panel, start, end, valid: panel.dataset.enabled === 'true' && !!panel.dataset.code?.trim() && Number.isFinite(start) && Number.isFinite(end) && end > start };
      }
      refresh() {
        if (!this.isConnected) return;
        clearTimeout(this.scheduleTimer);
        const now = Date.now();
        const periods = this.panels.filter(panel => panel.dataset.panel !== 'manual').map(panel => this.period(panel));
        const matches = periods.filter(period => period.valid && now >= period.start && now < period.end);
        let active = this.dataset.mode === 'manual' ? this.panels.find(panel => panel.dataset.panel === 'manual' && panel.dataset.code.trim()) : matches[0]?.panel;
        const livePanel = active;
        if (this.editor) {
          active = this.panels.find(panel => panel.dataset.panel === this.selectedId) || active || (this.dataset.mode === 'scheduled' ? (periods[0]?.panel || this.panels[0]) : this.panels[0]);
          if (this.note) {
            this.note.textContent = active === livePanel ? 'Anteprima del banner attualmente visibile sul sito.' : 'Solo anteprima editor: questo periodo non è attualmente visibile sul sito. Verifica attivazione, date e codice.';
            if (this.dataset.mode === 'scheduled' && matches.length > 1) this.note.textContent += ' Periodi sovrapposti: sul sito ha precedenza il primo nell’elenco.';
          }
        }
        if (this.currentPanel !== active) {
          this.copyVersion++;
          clearTimeout(this.copyTimer);
          this.status.textContent = '';
          this.status.classList.remove('czbf-status--error');
          this.panels.forEach(panel => {
            panel.hidden = panel !== active;
            panel.querySelector('[data-copy-label]').textContent = this.dataset.copy;
          });
          this.currentPanel = active;
        }
        this.hidden = !active;
        if (this.dataset.mode === 'scheduled') {
          const next = periods.filter(period => period.valid).flatMap(period => [period.start, period.end]).filter(time => time > now);
          const wait = next.length ? Math.max(50, Math.min(60000, Math.min(...next) - now + 50)) : 60000;
          this.scheduleTimer = setTimeout(() => this.refresh(), wait);
        }
      }
      async copyCode(button) {
        const panel = button.closest('[data-panel]');
        const code = panel.dataset.code;
        if (!code || button.disabled) return;
        const version = ++this.copyVersion;
        clearTimeout(this.copyTimer);
        let success = false;
        try {
          if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(code); success = true; }
        } catch { success = false; }
        if (!this.isConnected || version !== this.copyVersion || panel !== this.currentPanel) return;
        if (!success) {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(button.querySelector('.czbf-code'));
          selection.removeAllRanges();
          selection.addRange(range);
          try { success = document.execCommand('copy'); } catch { success = false; }
          if (success) selection.removeAllRanges();
        }
        const label = button.querySelector('[data-copy-label]');
        label.textContent = success ? this.dataset.copied : this.dataset.failed;
        this.status.classList.toggle('czbf-status--error', !success);
        this.status.textContent = (success ? this.dataset.copied : this.dataset.failed) + ': ' + code;
        if (success) this.copyTimer = setTimeout(() => {
          if (this.isConnected && version === this.copyVersion) { label.textContent = this.dataset.copy; this.status.textContent = ''; }
        }, 1500);
      }
    }
    customElements.define('cz-bf-banner', CZBFMonthBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfcm-popup-copping-zone"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cz-bfcm-popup')) {
  customElements.define('cz-bfcm-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        this.initialize();
      });
    }
    initialize() {
      const config = this.querySelector('[data-bfcm-config]');
      if (!config) return;
      try { this.config = JSON.parse(config.textContent); } catch { return; }
      this.initialized = true;
      this.controller = new AbortController();
      this.started = performance.now();
      this.lastClock = this.started;
      this.wasVisible = !document.hidden;
      this.pageReadyAt = this.started + 2000;
      this.deferUntil = 0;
      this.baseTime = Number(this.config.serverTime) || Date.now();
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.strings = this.config.strings;
      this.phases = this.config.phases.map(p => ({ id: p.id, ...p.settings }));
      this.pending = this.read('pending', true);
      this.phase = this.choosePhase();
      this.loadVisit();
      this.bind();
      this.timer = setInterval(() => this.tick(), 500);
      if (!this.phase) return;
      this.render();
      const state = this.querySelector('[data-form-status]').dataset.formStatus;
      const hasPending = this.pending && this.now() - this.pending.time < 1800000;
      const hasAnchor = location.hash === '#' + this.config.formId;
      if (!this.config.editor && (hasPending || hasAnchor) && state === 'success') {
        this.write('submitted', this.now());
        this.erase('pending', true);
        this.pending = null;
        this.cleanReturnUrl();
        this.showSuccess();
        this.open('result');
      } else if (!this.config.editor && (hasPending || hasAnchor) && state === 'error') {
        this.erase('pending', true);
        this.pending = null;
        this.open('result');
        const details = this.querySelector('[data-newsletter]');
        details.hidden = false;
        details.open = true;
      } else if (this.config.editor && this.config.editorOpen) {
        this.open('editor');
      }
      this.tick();
    }
    disconnectedCallback() {
      if (this.initialized) this.saveVisitClock(true);
      this.controller?.abort();
      clearInterval(this.timer);
      clearTimeout(this.cartTimer);
      clearTimeout(this.submitTimer);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
      this.initialized = false;
    }
    now() { return this.baseTime + performance.now() - this.started; }
    read(key, session = false) {
      try { return JSON.parse((session ? sessionStorage : localStorage).getItem(this.config.key + ':' + key)); } catch { return null; }
    }
    write(key, value, session = false) {
      if (this.config.editor) return;
      try { (session ? sessionStorage : localStorage).setItem(this.config.key + ':' + key, JSON.stringify(value)); } catch {}
    }
    erase(key, session = false) {
      if (this.config.editor) return;
      try { (session ? sessionStorage : localStorage).removeItem(this.config.key + ':' + key); } catch {}
    }
    loadVisit() {
      const saved = this.read('popup_v2:visit', true);
      if (saved && Number.isFinite(saved.lastSeen) && this.now() - saved.lastSeen < 1800000) {
        this.visit = { activeMs: Math.max(0, Number(saved.activeMs) || 0), lastSeen: saved.lastSeen, shown: !!saved.shown };
      } else {
        this.visit = { activeMs: 0, lastSeen: this.now(), shown: false };
      }
      this.write('popup_v2:visit', this.visit, true);
    }
    saveVisitClock(force = false) {
      if (!this.visit || this.config.editor) return;
      const clock = performance.now();
      const now = this.now();
      const expired = !this.wasVisible && !document.hidden && now - this.visit.lastSeen >= 1800000;
      if (expired) this.visit = { activeMs: 0, lastSeen: now, shown: false };
      if (this.wasVisible) this.visit.activeMs += Math.max(0, clock - this.lastClock);
      this.lastClock = clock;
      this.wasVisible = !document.hidden;
      if (!document.hidden) this.visit.lastSeen = now;
      if (force || !this.persistedAt || clock - this.persistedAt >= 1000) {
        this.write('popup_v2:visit', this.visit, true);
        this.persistedAt = clock;
      }
    }
    isSubscriber() {
      return !this.config.editor && (!!this.config.customerSubscribed || !!this.read('submitted'));
    }
    exposureKey() {
      const p = this.phase;
      return 'popup_v2:offer:' + [p.key, p.mode, p.discount, p.tier, p.minimum, p.code || ''].join('|');
    }
    recordExposure() {
      if (this.config.editor || !this.phase) return;
      this.visit.shown = true;
      this.lastExposure = this.now();
      this.lastExposureKey = this.exposureKey();
      this.write(this.lastExposureKey, this.lastExposure);
      this.saveVisitClock(true);
    }
    text(selector, value) {
      const node = this.querySelector(selector);
      if (node) node.textContent = value || '';
    }
    format(value, extra = {}) {
      const p = this.phase || {};
      const map = { discount: p.discount, tier: p.tier, minimum: p.minimum, ...extra };
      return String(value || '').replace(/\[([a-z_]+)\]/g, (all, key) => map[key] ?? all);
    }
    choosePhase() {
      if (!this.config.enabled && !this.config.editor) return null;
      if (!this.config.editor) {
        if (this.now() < this.config.campaignStart || this.now() >= this.config.campaignEnd || this.now() >= this.config.nextChange) return null;
        return this.phases[0] || null;
      }
      let phase;
      if (this.config.editor && this.previewId) phase = this.phases.find(p => p.id === this.previewId);
      if (!phase && !this.config.automatic) phase = this.phases.find(p => p.key === this.config.manualPhase);
      if (!phase) phase = this.phases.find(p => this.now() >= Date.parse(p.start) && this.now() < Date.parse(p.end));
      if (!phase && this.config.editor) phase = this.phases[0];
      return phase || null;
    }
    bind() {
      const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal: this.controller.signal });
      on(this, 'click', event => {
        const button = event.target.closest('[data-action]');
        if (!button) return;
        const action = button.dataset.action;
        if (action === 'preview' && this.config.editor) this.open('editor');
        if (action === 'close') this.dialog.close();
        if (action === 'copy') this.copyCode();
      });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      on(this.dialog, 'close', () => {
        this.unlockScroll();
        if (!this.config.editor && !this.silentClose) this.recordExposure();
        this.silentClose = false;
      });
      for (const name of ['cart:update', 'cart:updated', 'cart:change', 'cart-section:restored']) {
        on(document, name, () => {
          this.cartTime = 0;
          if (this.dialog.open && this.phase?.mode === 'tier') {
            clearTimeout(this.cartTimer);
            this.cartTimer = setTimeout(() => this.refreshCart(), 250);
          }
        });
      }
      on(window, 'pagehide', () => { this.saveVisitClock(true); this.wasVisible = false; });
      on(window, 'pageshow', event => {
        if (event.persisted) {
          this.loadVisit();
          this.pageReadyAt = performance.now() + 2000;
        } else {
          this.saveVisitClock(true);
        }
        this.wasVisible = !document.hidden;
        this.lastClock = performance.now();
        this.resetSubmit();
        if (this.dialog.open) this.refreshCart();
      });
      on(document, 'visibilitychange', () => {
        this.saveVisitClock(true);
        if (!document.hidden) { this.tick(); if (this.dialog.open) this.refreshCart(); }
      });
      on(this.form, 'submit', event => this.submit(event));
      on(this.querySelector('[data-apply]'), 'click', event => {
        if (this.config.editor) { event.preventDefault(); this.text('[data-status]', this.strings.preview); return; }
        const current = this.choosePhase();
        if (!current || current.id !== this.phase?.id) { event.preventDefault(); this.tick(); return; }
        this.recordExposure();
      });
      if (this.config.editor) {
        on(document, 'shopify:block:select', event => {
          if (!this.phases.some(p => p.id === event.detail.blockId)) return;
          this.previewId = event.detail.blockId;
          this.phase = this.choosePhase();
          this.success = false;
          this.render();
          this.open('editor');
        });
        on(document, 'shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open('editor');
        });
        on(document, 'shopify:section:deselect', event => {
          if (event.detail.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
        });
      }
    }
    tick() {
      this.saveVisitClock();
      if (document.hidden) return;
      if (!this.config.editor && this.config.enabled && this.now() >= this.config.nextChange && this.now() < this.config.campaignEnd) this.refreshPhase();
      const next = this.choosePhase();
      if (next?.id !== this.phase?.id) {
        this.phase = next;
        this.success = false;
        if (!next) {
          this.silentClose = true;
          if (this.dialog.open) this.dialog.close();
          return;
        }
        this.render();
      }
      if (!this.phase) return;
      if (this.canAutoOpen()) this.open('auto');
    }
    async refreshPhase() {
      if (this.phaseLoading || this.now() - (this.phaseAttempt || 0) < 30000) return;
      this.phaseLoading = true;
      this.phaseAttempt = this.now();
      try {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.delete('contact_posted');
        const response = await fetch(url.pathname + url.search, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = html.querySelector('[data-bfcm-config]');
        if (!node) return;
        const config = JSON.parse(node.textContent);
        if (!Number.isFinite(config.serverTime) || !Array.isArray(config.phases)) return;
        this.config = config;
        this.baseTime = config.serverTime;
        this.started = performance.now();
        this.strings = config.strings;
        this.phases = config.phases.map(p => ({ id: p.id, ...p.settings }));
        this.phase = this.choosePhase();
        this.success = false;
        if (this.phase) this.render();
      } catch {} finally { this.phaseLoading = false; }
    }
    canAutoOpen() {
      if (this.config.editor || !this.config.autoOpen || !this.phase || document.hidden) return false;
      if (this.dialog.open || this.visit.shown) return false;
      if (['signup', 'live'].includes(this.phase.mode) && this.isSubscriber()) return false;
      const key = this.exposureKey();
      const exposedAt = Number(this.read(key) || (this.lastExposureKey === key ? this.lastExposure : 0) || 0);
      if (exposedAt && this.now() - exposedAt < this.config.cooldown * 3600000) return false;
      if (this.visit.activeMs < this.config.delay * 1000 || performance.now() < this.pageReadyAt) return false;
      if (/(^|\/)(cart|checkout|checkouts|account|challenge)(\/|$)/.test(location.pathname)) return false;
      if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]') || this.otherOverlay()) {
        this.deferUntil = performance.now() + 2000;
        return false;
      }
      return performance.now() >= this.deferUntil;
    }
    otherOverlay() {
      return [...document.querySelectorAll('dialog[open], [aria-modal="true"], .shopify-pc__banner')].some(node => {
        if (node === this.dialog || node.closest('[hidden], [aria-hidden="true"], [inert]')) return false;
        if (node.tagName === 'DIALOG' && !node.hasAttribute('open')) return false;
        const box = node.getBoundingClientRect();
        if (box.width <= 0 || box.height <= 0 || box.bottom <= 0 || box.top >= innerHeight || box.right <= 0 || box.left >= innerWidth) return false;
        for (let parent = node; parent; parent = parent.parentElement) {
          const style = getComputedStyle(parent);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) < .05) return false;
        }
        return true;
      });
    }
    unlockScroll() {
      if (this.scrollLocked) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
    }
    render() {
      const p = this.phase;
      if (!p) return;
      const early = p.mode === 'signup' || p.mode === 'live';
      const tier = p.mode === 'tier';
      this.dialog.dataset.kind = p.mode;
      this.text('[data-eyebrow]', p.eyebrow);
      this.text('[data-title]', this.format(p.title));
      this.text('[data-body]', this.format(p.body));
      this.text('[data-date]', p.date_label);
      this.text('[data-mode-label]', early ? this.strings.subscribers : this.strings.public_offer);
      this.querySelector('[data-value-wrap]').hidden = p.mode === 'signup';
      this.text('[data-value]', tier ? p.tier : p.discount);
      this.querySelector('[data-extra]').hidden = !this.config.baseReduction;
      this.querySelector('[data-tiers]').hidden = !tier;
      this.text('[data-low-label]', this.format(this.strings.one_item));
      this.text('[data-high-label]', this.format(this.strings.more_items));
      const prefix = this.config.baseReduction ? this.strings.extra[0] + this.strings.extra.slice(1).toLowerCase() + ' ' : '';
      this.text('[data-low-rate]', prefix + p.discount + '%');
      this.text('[data-high-rate]', prefix + p.tier + '%');
      this.querySelector('[data-tier-low]').removeAttribute('data-current');
      this.querySelector('[data-tier-high]').removeAttribute('data-current');
      this.querySelector('[data-cart-note]').hidden = true;
      const total = this.querySelector('[data-total]');
      total.hidden = !this.config.baseReduction || p.mode === 'signup';
      const totalRate = rate => Number((100 - (100 - this.config.baseReduction) * (100 - rate) / 100).toFixed(2));
      this.text('[data-total]', this.format(tier ? this.strings.total_tier : this.strings.total, { total: totalRate(p.discount), total_tier: totalRate(p.tier), base: this.config.baseReduction }));
      this.querySelector('[data-public]').hidden = early;
      const code = String(p.code || '').trim();
      this.text('[data-code]', code);
      this.text('[data-action="copy"]', this.strings.copy);
      this.querySelector('[data-code-row]').hidden = !code;
      this.text('[data-apply-label]', code ? p.button : this.strings.shop);
      const apply = this.querySelector('[data-apply]');
      const redirect = this.returnPath();
      apply.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect) : this.safeShopUrl();
      this.text('[data-submit-label]', early ? p.button : this.strings.subscribe);
      this.form.querySelector('[data-tags]').value = 'newsletter, BFCM_2026, ' + (early ? this.config.earlyTag : this.config.publicTag);
      this.text('[data-status]', '');
      this.querySelector('[data-success]').hidden = !this.success;
      this.querySelector('[data-known]').hidden = !(early && this.isSubscriber() && !this.success);
      this.text('[data-known]', p.mode === 'live' ? this.strings.known_live : this.strings.known_early);
      const newsletter = this.querySelector('[data-newsletter]');
      newsletter.hidden = !!this.success || this.isSubscriber() || (!early && !this.config.showEmail);
      newsletter.open = early;
      newsletter.toggleAttribute('data-primary', early);
      if (this.dialog.open) this.refreshCart();
    }
    safeShopUrl() {
      try {
        const url = new URL(this.config.shopUrl, location.origin);
        return url.origin === location.origin ? url.pathname + url.search : this.config.root + 'collections/all';
      } catch { return this.config.root + 'collections/all'; }
    }
    returnPath() {
      if (/(^|\/)(contact|challenge|account|checkout|checkouts)(\/|$)/.test(location.pathname)) return this.safeShopUrl();
      const url = new URL(location.href);
      for (const key of ['contact_posted', 'customer_posted', 'form_type', 'return_to']) url.searchParams.delete(key);
      return url.pathname + url.search;
    }
    cleanReturnUrl() {
      try {
        const url = new URL(location.href);
        for (const key of ['contact_posted', 'customer_posted', 'form_type', 'return_to']) url.searchParams.delete(key);
        if (url.hash === '#' + this.config.formId) url.hash = '';
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      } catch {}
    }
    open(reason) {
      if (!this.phase || this.dialog.open || !this.dialog.showModal) return;
      if (reason === 'auto' && this.otherOverlay()) return;
      if (reason !== 'result') this.render();
      this.dialog.showModal();
      this.previousOverflow = document.documentElement.style.overflow;
      this.scrollLocked = true;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.scrollTop = 0;
      this.querySelector('[data-title]').focus({ preventScroll: true });
      if (!this.config.editor) this.recordExposure();
      this.refreshCart();
    }
    async refreshCart() {
      if (!this.phase || this.phase.mode !== 'tier' || !this.dialog.open || this.config.editor || this.cartLoading) return;
      if (this.cartTime && this.now() - this.cartTime < 5000) return;
      this.cartLoading = true;
      try {
        const response = await fetch(this.config.root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (!Array.isArray(cart.items) || this.phase?.mode !== 'tier') return;
        const count = cart.items.filter(item => !item.gift_card).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
        this.cartTime = this.now();
        this.querySelector('[data-tier-low]').toggleAttribute('data-current', count > 0 && count < this.phase.minimum);
        this.querySelector('[data-tier-high]').toggleAttribute('data-current', count >= this.phase.minimum);
        const message = count >= this.phase.minimum ? this.strings.cart_ready : (count === this.phase.minimum - 1 ? this.strings.cart_one_more : this.strings.cart_more);
        this.text('[data-cart-note]', this.format(message, { remaining: Math.max(0, this.phase.minimum - count), extra: this.config.baseReduction ? this.strings.extra.toLowerCase() + ' ' : '' }));
        this.querySelector('[data-cart-note]').hidden = count === 0;
      } catch {} finally { this.cartLoading = false; }
    }
    async copyCode() {
      const code = String(this.phase?.code || '').trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        this.text('[data-action="copy"]', this.strings.copied);
        this.text('[data-status]', this.strings.copied);
      } catch {
        const range = document.createRange();
        range.selectNodeContents(this.querySelector('[data-code]'));
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        this.text('[data-status]', this.strings.copy_manual);
      }
    }
    submit(event) {
      if (!this.form.checkValidity()) { event.preventDefault(); this.form.reportValidity(); return; }
      if (this.config.editor) { event.preventDefault(); this.showSuccess(); return; }
      const current = this.choosePhase();
      if (!current || current.id !== this.phase?.id) { event.preventDefault(); this.tick(); this.text('[data-status]', this.strings.changed); return; }
      this.write('pending', { time: this.now(), phase: this.phase.id }, true);
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;
      this.text('[data-submit-label]', this.strings.sending);
      clearTimeout(this.submitTimer);
      this.submitTimer = setTimeout(() => this.resetSubmit(), 20000);
    }
    resetSubmit() {
      if (!this.phase || !this.form) return;
      this.form.querySelector('[type="submit"]').disabled = false;
      this.text('[data-submit-label]', ['signup', 'live'].includes(this.phase.mode) ? this.phase.button : this.strings.subscribe);
    }
    showSuccess() {
      this.success = true;
      this.querySelector('[data-newsletter]').hidden = true;
      this.querySelector('[data-known]').hidden = true;
      this.querySelector('[data-success]').hidden = false;
      const key = this.phase.mode === 'signup' ? 'signup_success_early' : this.phase.mode === 'live' ? 'signup_success_live' : 'signup_success_public';
      this.text('[data-success-body]', this.config.editor ? this.strings.preview : this.strings[key]);
      this.resetSubmit();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-app5-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cz-app5-popup')) return;

  class CZApp5Popup extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      if (!this.querySelector('[data-dialog]')) {
        this._ready = () => this.connectedCallback();
        document.addEventListener('DOMContentLoaded', this._ready, { once: true });
        return;
      }
      this._bound = true;
      this._abort = new AbortController();
      this._timers = new Set();
      this._queue = [];
      this._sent = new Set();
      this._flushing = false;
      this._submitting = false;
      this._flipEpoch = 0;
      this._flipping = false;
      this._revealed = false;
      this._storageKey = 'cz_app5_popup_v1';
      this._pendingKey = 'cz_app5_pending_v1';
      try { this.config = JSON.parse(this.dataset.config || '{}'); } catch (_) { this.config = {}; }
      this.strings = this.config;
      try { this.local = window.localStorage; } catch (_) {}
      try { this.session = window.sessionStorage; } catch (_) {}
      this.dialog = this.querySelector('[data-dialog]');
      this.overlay = this.querySelector('[data-overlay]');
      this.form = this.querySelector('[data-signup-form]');
      this.email = this.querySelector('[data-email]');
      this.live = this.querySelector('[data-live]');
      this.stage = 'cards';
      this.card = '';
      this.interactionId = this.newId();
      this.demo = Boolean(window.Shopify?.designMode) || this.dataset.designMode === 'true' ||
        new URL(location.href).searchParams.get('cz_app5_preview') === '1';
      this.storage = this.read(this.local, this._storageKey) || {};
      this.pending = this.read(this.session, this._pendingKey);
      if (this.pending && (!Number.isFinite(this.pending.at) || Date.now() - this.pending.at > 7200000 ||
          this.pending.formId !== this.form?.id)) {
        this.remove(this.session, this._pendingKey);
        this.pending = null;
      }
      const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: this._abort.signal });
      this.querySelectorAll('[data-card]').forEach(el => { el.dataset.originalLabel = el.getAttribute('aria-label') || ''; on(el, 'click', () => this.pickCard(el)); });
      on(this.querySelector('[data-claim]'), 'click', () => { if (this._revealed) this.showStage('email', true); });
      this.querySelectorAll('[data-close]').forEach(el => on(el, 'click', () => this.dismiss()));
      on(this.querySelector('[data-back]'), 'click', () => this.showStage('cards', true));
      on(this.dialog, 'cancel', event => { event.preventDefault(); this.dismiss(); });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dismiss();
      });
      on(this.dialog, 'close', () => { this.cancelFlip(); if (this.stage === 'cards') this.resetCards(); if (this.overlay) this.overlay.hidden = true; this.unlock(); });
      on(this.overlay, 'click', () => this.dismiss());
      on(document, 'keydown', event => this.keyboard(event));
      on(this.form, 'submit', event => this.submit(event));
      on(this.querySelector('[data-copy]'), 'click', () => this.copy());
      this.querySelectorAll('[data-store]').forEach(el => on(el, 'click', () => this.track('store_click', { store_target: el.dataset.store })));
      this.querySelectorAll('[data-preview-stage]').forEach(el => on(el, 'click', () => {
        if (this.demo) { this.card = this.card || '1'; this.showStage(el.dataset.previewStage, true); this.open(false); }
      }));
      on(document, 'shopify:section:select', event => {
        if (this.demo && (event.detail?.sectionId === this.dataset.sectionId || event.target?.contains(this))) this.open(false);
      });
      on(window, 'pageshow', event => {
        if (event.persisted) {
          this.cancelFlip();
          if (this.stage === 'cards') this.resetCards();
          this.setSubmitting(false);
          const saved = this.read(this.local, this._storageKey) || {};
          if (Number(saved.completeUntil) > Date.now() && this.dialog.open) {
            this.dialog.close();
          } else if (!this.read(this.session, this._pendingKey) && this.stage === 'email') this.showStage('email', false);
        }
      });
      const android = /Android/i.test(navigator.userAgent);
      this.dataset.preferredStore = android ? 'android' : 'ios';
      const preferred = this.querySelector(`[data-store="${this.dataset.preferredStore}"]`);
      if (preferred?.parentElement) preferred.parentElement.prepend(preferred);
      if (this.demo) {
        this.dataset.previewMode = 'true';
        this.showStage(['cards', 'email', 'reward'].includes(this.config.editorStage) ? this.config.editorStage : 'cards');
        this.later(() => this.open(false), 180);
        return;
      }
      if (this.restoreSubmission()) return;
      if (this.suppressed()) return;
      const delay = Math.max(0, Number(this.config.delay ?? 12)) * 1000;
      this.later(() => this.tryOpen(0), delay);
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this._ready);
      this.cancelFlip();
      this._abort?.abort();
      this._timers?.forEach(id => clearTimeout(id));
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
      this._bound = false;
    }

    newId() {
      return window.crypto?.randomUUID?.() || 'cz_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
    }

    read(storage, key) {
      try { return JSON.parse(storage.getItem(key) || 'null'); } catch (_) { return null; }
    }

    write(storage, key, value) {
      try { storage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; }
    }

    remove(storage, key) { try { storage.removeItem(key); } catch (_) {} }

    later(fn, ms) {
      const id = setTimeout(() => { this._timers.delete(id); if (this.isConnected) fn(); }, ms);
      this._timers.add(id);
      return id;
    }

    excluded() {
      const url = new URL(location.href);
      const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
      if (/^\/(?:cart|checkout|checkouts|account|challenge|password)(?:\/|$)/i.test(path)) return true;
      if ([...url.searchParams.keys()].some(key => key.toLowerCase() === 'mystery')) return true;
      if (/cz-recover|mystery(?:%3d|=)/i.test(url.hash + url.search)) return true;
      return false;
    }

    suppressed() {
      const state = this.read(this.local, this._storageKey) || {};
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      return (mobile && this.config.showMobile === false) || (!mobile && this.config.showDesktop === false) || this.config.enabled === false || this.dataset.knownSubscriber === 'true' || this.excluded() ||
        Number(state.dismissUntil) > Date.now() || Number(state.completeUntil) > Date.now();
    }

    otherDialog() {
      return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner')]
        .some(el => el !== this.dialog && !this.contains(el) && el.getClientRects().length > 0 &&
          getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none');
    }

    tryOpen(retries) {
      if (this.suppressed()) return;
      if (document.hidden || this.otherDialog()) {
        if (retries < 60) this.later(() => this.tryOpen(retries + 1), 2000);
        return;
      }
      this.showStage('cards');
      this.open(true);
    }

    open(countView) {
      if (!this.dialog || typeof this.dialog.show !== 'function' || this.dialog.open) return;
      this._focusBefore = document.activeElement;
      if (this.overlay) this.overlay.hidden = false;
      this.dialog.show();
      this.querySelector(`section[data-stage="${this.stage}"] h3`)?.focus({ preventScroll: true });
      document.documentElement.classList.add('cz-app5-scroll-lock');
      if (countView) this.track('view');
    }

    keyboard(event) {
      if (!this.dialog?.open || !this.dialog.contains(document.activeElement)) return;
      if (event.key === 'Escape') { event.preventDefault(); this.dismiss(); return; }
      if (event.key !== 'Tab' || this._submitting) return;
      const items = [...this.dialog.querySelectorAll('button:not(:disabled), a[href], input:not([type="hidden"]):not(:disabled), [tabindex="0"]')]
        .filter(el => el.getClientRects().length > 0);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }

    unlock() {
      if (!document.querySelector('cz-app5-popup dialog[open]')) document.documentElement.classList.remove('cz-app5-scroll-lock');
    }

    dismiss() {
      if (!this.dialog.open) return;
      this.track('dismiss');
      if (!this.demo && this.stage !== 'reward') {
        const state = this.read(this.local, this._storageKey) || {};
        state.dismissUntil = Date.now() + Number(this.config.dismissDays ?? 7) * 86400000;
        this.write(this.local, this._storageKey, state);
      }
      this.dialog.close();
      this.unlock();
      if (this._focusBefore?.isConnected && this._focusBefore !== document.body) this._focusBefore.focus({ preventScroll: true });
    }

    cancelFlip() {
      this._flipEpoch = (this._flipEpoch || 0) + 1;
      if (this._flipTimer) { clearTimeout(this._flipTimer); this._timers?.delete(this._flipTimer); }
      if (this._advanceTimer) { clearTimeout(this._advanceTimer); this._timers?.delete(this._advanceTimer); }
      this._flipCleanup?.();
      this._flipCleanup = null;
      this._flipping = false;
    }

    resetCards() {
      this.cancelFlip();
      this._revealed = false;
      this.card = '';
      delete this.dataset.picked;
      delete this.dataset.revealed;
      delete this.dataset.selectedCard;
      this.querySelectorAll('[data-card]').forEach(el => {
        el.classList.remove('is-selected', 'is-flipped');
        el.disabled = false;
        el.setAttribute('aria-pressed', 'false');
        el.setAttribute('aria-label', el.dataset.originalLabel || '');
      });
      const claim = this.querySelector('[data-claim]');
      const hint = this.querySelector('[data-reveal-hint]');
      const cardHint = this.querySelector('[data-card-hint]');
      if (cardHint) cardHint.hidden = false;
      if (claim) claim.hidden = true;
      if (hint) hint.hidden = true;
    }

    pickCard(el) {
      if (this.stage !== 'cards' || this._flipping || this._revealed || !this.dialog?.open) return;
      this.cancelFlip();
      const epoch = this._flipEpoch;
      this._flipping = true;
      this.card = el.dataset.card;
      this.dataset.selectedCard = this.card;
      this.dataset.picked = 'true';
      this.querySelectorAll('[data-card]').forEach(card => {
        card.disabled = card !== el;
        card.setAttribute('aria-pressed', card === el ? 'true' : 'false');
      });
      el.classList.add('is-selected');
      this.track('card_select');
      const inner = el.querySelector('[data-card-inner]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let finished = false;
      const finish = () => {
        if (finished || epoch !== this._flipEpoch || !this.isConnected || !this.dialog.open || this.stage !== 'cards') return;
        finished = true;
        this._flipCleanup?.();
        this._flipCleanup = null;
        this._flipping = false;
        this._revealed = true;
        this.dataset.revealed = 'true';
        const claim = this.querySelector('[data-claim]');
        const hint = this.querySelector('[data-reveal-hint]');
        if (claim) claim.hidden = false;
        if (hint) hint.hidden = false;
        const cardHint = this.querySelector('[data-card-hint]');
        if (cardHint) cardHint.hidden = true;
        const announcement = (this.config.revealAnnouncement || '').replaceAll('[percent]', String(this.config.percent || 5));
        if (this.live) { this.live.classList.add('cz-app5__sr-only'); this.live.textContent = announcement; }
        if (announcement) el.setAttribute('aria-label', announcement);
        if (this.config.autoAdvance === true) {
          this._advanceTimer = this.later(() => {
            if (epoch === this._flipEpoch && this.dialog.open && this.stage === 'cards') this.showStage('email', true);
          }, Math.max(500, Number(this.config.revealHold ?? 1200)));
        }
      };
      if (inner) {
        const end = event => { if (event.target === inner && event.propertyName === 'transform') finish(); };
        inner.addEventListener('transitionend', end);
        this._flipCleanup = () => inner.removeEventListener('transitionend', end);
      }
      void el.offsetWidth;
      el.classList.add('is-flipped');
      this._flipTimer = this.later(finish, reducedMotion ? 16 : Math.max(0, Number(this.config.flipDuration ?? 800)) + 100);
    }

    showStage(stage, focus = false) {
      if (!['cards', 'email', 'reward'].includes(stage)) return;
      this.cancelFlip();
      if (stage === 'cards') this.resetCards();
      this.stage = stage;
      this.dataset.stage = stage;
      this.querySelectorAll('[data-stage]').forEach(el => { el.hidden = el.dataset.stage !== stage; });
      if (this.live) { this.live.textContent = ''; this.live.classList.remove('cz-app5__sr-only'); }
      if (focus) this.later(() => {
        const el = stage === 'email' ? this.email : this.querySelector(`section[data-stage="${stage}"] button, section[data-stage="${stage}"] a`);
        el?.focus({ preventScroll: true });
      }, 40);
    }

    setSubmitting(busy) {
      this._submitting = busy;
      if (busy) this.form?.setAttribute('aria-busy', 'true');
      else this.form?.removeAttribute('aria-busy');
      const label = this.querySelector('[data-submit] > span:not([aria-hidden])');
      if (label) label.textContent = busy ? this.strings.submitting : this.strings.submitLabel;
    }

    submit(event) {
      if (this.demo) {
        event.preventDefault();
        if (this.form.reportValidity()) this.showStage('reward', true);
        return;
      }
      if (!this.form.checkValidity()) return;
      if (this._submitting) return;
      this.setSubmitting(true);
      const pending = { formId: this.form.id, card: this.card, at: Date.now(), path: location.pathname,
        interactionId: this.interactionId, viewTracked: this._sent.has('view') };
      this.write(this.session, this._pendingKey, pending);
      this.track('submit_attempt');
      this.later(() => this.setSubmitting(false), 12000);
    }

    restoreSubmission() {
      if (!this.pending) return false;
      const state = this.querySelector('[data-form-state]');
      this.card = ['1', '2', '3'].includes(this.pending.card) ? this.pending.card : '1';
      this.setAttribute('data-selected-card', this.card);
      this.interactionId = this.pending.interactionId || this.newId();
      if (this.pending.viewTracked) this._sent.add('view');
      if (state?.dataset.error === 'true') {
        this.remove(this.session, this._pendingKey);
        this.showStage('email');
        this.open(false);
        this.later(() => this.email?.focus(), 60);
        return true;
      }
      if (state?.dataset.success === 'true') {
        this.remove(this.session, this._pendingKey);
        const saved = this.read(this.local, this._storageKey) || {};
        saved.completeUntil = Date.now() + Number(this.config.revealDays ?? 180) * 86400000;
        this.write(this.local, this._storageKey, saved);
        this.showStage('reward');
        this.open(false);
        if (this.pending.viewTracked) this.track('submit_success');
        return true;
      }
      this.remove(this.session, this._pendingKey);
      this.showStage('email');
      const retry = this.querySelector('[data-retry]');
      if (retry) retry.hidden = false;
      this.open(false);
      return true;
    }

    async copy() {
      const code = (this.querySelector('[data-code]')?.textContent || this.config.code || 'APP5').trim();
      let success = false;
      try {
        if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(code); success = true; }
      } catch (_) {}
      if (!success) {
        const field = document.createElement('textarea');
        field.value = code;
        field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        this.dialog.appendChild(field);
        field.select();
        try { success = document.execCommand('copy'); } catch (_) {}
        field.remove();
      }
      if (this.live) this.live.textContent = success ? (this.strings.copied || 'Code copied. See you in the app.') :
        (this.strings.copyFallback || 'Your code is APP5. Enter it at checkout in the app.');
      if (success) this.track('copy_code');
    }

    track(action, extra = {}) {
      if (this.demo) return;
      if (['view', 'submit_success'].includes(action)) {
        if (this._sent.has(action)) return;
        this._sent.add(action);
      }
      this._queue.push({ action, popup_id: this.dataset.popupId || 'cz_app5_v1', selected_card: this.card,
        interaction_id: this.interactionId, store_target: extra.store_target || '' });
      this.flush(0);
    }

    flush(attempt) {
      if (this._flushing) return;
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        while (this._queue.length) {
          const data = this._queue.shift();
          try { window.Shopify.analytics.publish('cz_app5_popup', data); } catch (_) {}
        }
      } else if (attempt < 12 && this._queue.length) {
        this._flushing = true;
        this.later(() => { this._flushing = false; this.flush(attempt + 1); }, 800);
      }
    }
  }
  customElements.define('cz-app5-popup', CZApp5Popup);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-brands"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cz-brands')) {
    class CZBrands extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.input = this.querySelector('[data-search]');
        this.directory = this.querySelector('[data-directory]');
        this.controls = this.querySelector('[data-controls]');
        this.live = this.querySelector('[data-live]');
        this.status = this.querySelector('[data-availability-message]');
        this.allLabel = this.config.all;
        this.entries = [...this.querySelectorAll('[data-brand]')].map(node => ({
          node,
          vendor: node.dataset.vendor,
          name: node.dataset.name,
          search: this.normalize(`${node.dataset.name} ${node.dataset.vendor} ${node.dataset.aliases}`),
          available: true
        })).sort((a, b) => a.name.localeCompare(b.name, document.documentElement.lang || 'en', { sensitivity: 'base' }));
        this.groups = [];
        const source = this.querySelector('[data-source]');
        const alphabet = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        alphabet.forEach(letter => {
          const entries = this.entries.filter(entry => {
            const first = this.normalize(entry.name).charAt(0).toUpperCase();
            return (/[A-Z]/.test(first) ? first : '#') === letter;
          });
          if (!entries.length) return;
          const group = document.createElement('section');
          group.className = 'cz-brands__group';
          const title = document.createElement('h3');
          title.id = `${this.id}-letter-${letter === '#' ? 'other' : letter}`;
          title.tabIndex = -1;
          title.textContent = letter;
          group.setAttribute('aria-labelledby', title.id);
          const list = document.createElement('ul');
          list.className = 'cz-brands__links';
          entries.forEach(entry => list.append(entry.node));
          group.append(title, list);
          this.directory.append(group);
          this.groups.push({ letter, entries, group, title });
        });
        source.remove();
        this.activeLetter = null;
        this.buildAlphabet(alphabet);
        this.controls.hidden = false;
        this.querySelector('[data-reset]').hidden = false;
        this.input.addEventListener('input', () => { this.activeLetter = null; this.filter(); }, { signal });
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); this.reset(); }
        }, { signal });
        this.querySelector('[data-clear]').addEventListener('click', () => this.reset(), { signal });
        this.querySelector('[data-reset]').addEventListener('click', () => this.reset(), { signal });
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.measure(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true, signal });
        window.addEventListener('resize', this.onScroll, { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.controls);
        this.status.textContent = this.dataset.onlyAvailable === 'true' ? this.config.checking : this.config.allStatus;
        this.filter(false);
        this.measure();
        if (this.dataset.onlyAvailable === 'true' && this.entries.length) this.checkAvailability();
      }

      normalize(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
      }

      buildAlphabet(alphabet) {
        const nav = this.querySelector('[data-alphabet]');
        this.navItems = [];
        [null, ...alphabet].forEach(letter => {
          const link = document.createElement('a');
          link.textContent = letter || this.allLabel;
          const group = this.groups.find(item => item.letter === letter);
          link.href = `#${group ? group.title.id : this.directory.id}`;
          link.addEventListener('click', event => {
            event.preventDefault();
            if (!letter) {
              this.input.value = '';
              this.activeLetter = null;
              this.filter();
              this.scrollToElement(this.directory);
            } else if (group && !group.group.hidden) {
              this.activeLetter = letter;
              this.updateAlphabet();
              this.scrollToElement(group.title);
            }
          }, { signal: this.controller.signal });
          const disabled = document.createElement('span');
          disabled.textContent = letter || this.allLabel;
          disabled.setAttribute('aria-disabled', 'true');
          disabled.hidden = true;
          nav.append(link, disabled);
          this.navItems.push({ letter, link, disabled, group });
        });
      }

      scrollToElement(element) {
        this.measure();
        const styles = getComputedStyle(this);
        const top = parseFloat(styles.getPropertyValue('--czb-header')) || 0;
        const extra = parseFloat(styles.getPropertyValue('--czb-offset')) || 0;
        const sticky = getComputedStyle(this.controls).position === 'sticky';
        const offset = sticky ? this.controls.getBoundingClientRect().height + top + extra + 24 : 24;
        element.focus({ preventScroll: true });
        window.scrollTo({ top: window.scrollY + element.getBoundingClientRect().top - offset, behavior: 'instant' });
      }

      reset() {
        this.input.value = '';
        this.activeLetter = null;
        this.filter();
        this.input.focus({ preventScroll: true });
      }

      filter(announce = true) {
        const terms = this.normalize(this.input.value).split(' ').filter(Boolean);
        const compact = terms.join('');
        let count = 0;
        this.groups.forEach(group => {
          let visible = 0;
          group.entries.forEach(entry => {
            const match = terms.every(term => entry.search.includes(term)) || entry.search.replaceAll(' ', '').includes(compact);
            entry.node.hidden = !entry.available || !match;
            if (!entry.node.hidden) visible++;
          });
          group.group.hidden = visible === 0;
          count += visible;
        });
        this.querySelector('[data-clear]').hidden = !this.input.value;
        this.querySelector('[data-empty]').hidden = count !== 0;
        const label = count === 1 ? this.config.countOne : this.config.count.replace('{count}', String(count));
        this.dataset.filtering = String(terms.length > 0);
        this.querySelector('[data-result-count]').textContent = label;
        this.updateAlphabet();
        clearTimeout(this.announceTimer);
        if (announce) this.announceTimer = setTimeout(() => { this.live.textContent = label; }, 180);
      }

      updateAlphabet() {
        this.navItems.forEach(item => {
          const enabled = !item.letter || (item.group && !item.group.group.hidden);
          item.link.hidden = !enabled;
          item.disabled.hidden = Boolean(enabled);
          if (item.letter === this.activeLetter) item.link.setAttribute('aria-current', 'true');
          else item.link.removeAttribute('aria-current');
        });
      }

      measure() {
        let bottom = 0;
        const header = document.querySelector('header-component');
        if (header) {
          const rect = header.getBoundingClientRect();
          if (rect.top < 2 && rect.bottom > 0) bottom = rect.bottom;
        }
        this.style.setProperty('--czb-header', `${Math.round(bottom)}px`);
        this.style.setProperty('--czb-controls', `${Math.round(this.controls.getBoundingClientRect().height)}px`);
      }

      async checkAvailability() {
        const quote = value => `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
        const batches = [];
        for (let index = 0; index < this.entries.length; index += 35) batches.push(this.entries.slice(index, index + 35));
        try {
          const states = [];
          for (let index = 0; index < batches.length; index += 2) {
            const results = await Promise.all(batches.slice(index, index + 2).map(async batch => {
              const variables = { country: this.dataset.country || null };
              const declarations = ['$country: CountryCode'];
              const fields = batch.map((entry, i) => {
                declarations.push(`$q${i}: String!`);
                variables[`q${i}`] = `vendor:${quote(entry.vendor)} AND available_for_sale:true`;
                return `b${i}: products(first: 1, query: $q${i}) { nodes { vendor availableForSale onlineStoreUrl } }`;
              });
              const query = `query CZBrandAvailability(${declarations.join(', ')}) @inContext(country: $country) { ${fields.join(' ')} }`;
              const requestController = new AbortController();
              const abort = () => requestController.abort();
              this.controller.signal.addEventListener('abort', abort, { once: true });
              const timeout = setTimeout(abort, 9000);
              try {
                const response = await fetch('/api/2026-07/graphql.json', {
                  method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ query, variables }), signal: requestController.signal
                });
                if (!response.ok) throw new Error('Availability request failed');
                const payload = await response.json();
                if (payload.errors?.length || !payload.data) throw new Error('Availability response incomplete');
                return batch.map((entry, i) => {
                  const nodes = payload.data[`b${i}`]?.nodes;
                  if (!Array.isArray(nodes)) throw new Error('Missing vendor result');
                  if (nodes.some(product => product.vendor.toLowerCase() !== entry.vendor.toLowerCase())) throw new Error('Ambiguous vendor result');
                  return { entry, available: nodes.some(product => product.availableForSale && product.onlineStoreUrl) };
                });
              } finally {
                clearTimeout(timeout);
                this.controller.signal.removeEventListener('abort', abort);
              }
            }));
            states.push(...results.flat());
          }
          if (!this.isConnected) return;
          states.forEach(({ entry, available }) => { entry.available = available; });
          const count = states.filter(state => state.available).length;
          this.status.textContent = this.config.available.replace('{count}', count === 1 ? this.config.countOne : this.config.count.replace('{count}', String(count)));
          this.dataset.availability = 'verified';
          this.filter();
        } catch (error) {
          if (!this.isConnected || this.controller.signal.aborted) return;
          this.status.textContent = this.config.fallback;
          this.dataset.availability = 'unverified';
        }
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this.controller?.abort();
          this.resizeObserver?.disconnect();
          cancelAnimationFrame(this.frame);
          clearTimeout(this.announceTimer);
        });
      }
    }
    customElements.define('cz-brands', CZBrands);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-mystery-discount"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('cz-mystery-discount')) return;
  const entryUrl = new URL(location.href);
  let claimed = false;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sameCode = (a, b) => String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
  const rootUrl = () => `${(window.Shopify?.routes?.root || '/').replace(/\/$/, '')}/`;
  const publish = (name, data) => {
    try { window.Shopify?.analytics?.publish?.(name, { path: location.pathname, ...data }); } catch {}
  };
  const fetchJson = async (url, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(url, {
        credentials: 'same-origin', cache: 'no-store', ...options,
        headers: { Accept: 'application/json', ...options.headers }, signal: controller.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } finally { clearTimeout(timer); }
  };

  class CzMysteryDiscount extends HTMLElement {
    async connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      try { this.config = JSON.parse(this.dataset.config); }
      catch { return; }
      this.entryUrl = this.readEntryUrl();
      this.code = '';
      this.designMode = this.hasAttribute('data-design-mode');
      this.sectionId = this.dataset.sectionId;
      this.endsAt = this.parseEnd(this.config.endsAt);
      this.invalidEnd = Boolean(this.config.endsAt) && this.endsAt === null;
      this.applied = this.querySelector('[data-cz-md-applied]');
      this.appliedText = this.querySelector('[data-cz-md-applied-text]');
      this.appliedSub = this.querySelector('[data-cz-md-applied-sub]');
      this.announcement = this.querySelector('[data-cz-md-announcement]');
      this.countdown = this.querySelector('[data-cz-md-countdown]');
      this.dialog.addEventListener('click', this.onClick, { signal });
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close('escape'); }, { signal });
      this.dialog.addEventListener('close', () => this.unlockScroll(), { signal });
      if (this.designMode) { this.setupEditor(signal); return; }
      const trigger = await this.findTrigger();
      if (signal.aborted || !this.isConnected || !trigger || claimed) return;
      this.trigger = trigger;
      this.code = trigger.code;
      this.recoveryUrl = this.config.allowRecovery ? this.findRecovery() : null;
      if (!this.config.active || this.invalidEnd || this.expired()) {
        if (this.recoveryUrl) {
          claimed = true;
          this.cleanUrl();
          location.replace(this.recoveryUrl.href);
        }
        return;
      }
      claimed = true;
      this.cleanUrl();
      this.applyPromise = this.recoveryUrl
        ? Promise.resolve({ state: 'recovery', cart: null })
        : this.invalidRecovery
          ? Promise.resolve({ state: 'invalid-recovery', cart: null })
          : this.applyCode();
      const start = () => { this.openTimer = setTimeout(() => this.open(this.trigger.type), 350); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
      else start();
    }

    disconnectedCallback() {
      this.abort?.abort();
      ['openTimer', 'revealTimer', 'statusTimer', 'closeTimer', 'slowTimer'].forEach((key) => clearTimeout(this[key]));
      clearInterval(this.tick);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }

    parseEnd(value) {
      if (!value) return null;
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
      if (!match) return null;
      const [, year, month, day, hour, minute, second = '00'] = match;
      const days = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
      if (+month < 1 || +month > 12 || +day < 1 || +day > days || +hour > 23 || +minute > 59 || +second > 59) return null;
      const time = Date.parse(value);
      return Number.isFinite(time) ? time : null;
    }

    expired() { return this.endsAt !== null && Date.now() >= this.endsAt; }

    readEntryUrl() {
      const url = new URL(entryUrl.href);
      const param = String(this.config.param || 'mystery').toLowerCase();
      const explicit = [...url.searchParams].filter(([key]) => key.toLowerCase() === param);
      if (url.hash || explicit.length !== 1) return url;
      const [key, value] = explicit[0];
      const marker = value.indexOf('#cz-recover=');
      if (marker < 1 || value.indexOf('#', marker + 1) !== -1) return url;
      const fragment = value.slice(marker + 1);
      const parts = [...new URLSearchParams(fragment)];
      if (parts.length !== 1 || parts[0][0] !== 'cz-recover' || !parts[0][1]) return url;
      url.searchParams.set(key, value.slice(0, marker));
      url.hash = fragment;
      return url;
    }

    async matchesCode(candidate) {
      const normalized = String(candidate || '').trim().toUpperCase();
      const expected = String(this.config.codeHash || '').toLowerCase();
      if (!normalized || !/^[a-f0-9]{64}$/.test(expected) || !globalThis.crypto?.subtle) return false;
      try {
        const buffer = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized));
        const actual = Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
        return actual === expected;
      } catch { return false; }
    }

    async findTrigger() {
      const param = String(this.config.param || 'mystery').toLowerCase();
      const entries = [...this.entryUrl.searchParams];
      const explicit = entries.filter(([key]) => key.toLowerCase() === param);
      if (explicit.length) {
        const candidate = String(explicit[0][1] || '').trim();
        if (!candidate || !explicit.every(([, value]) => sameCode(value, candidate))) return null;
        return await this.matchesCode(candidate) ? { type: 'link', code: candidate } : null;
      }
      const normalize = (value) => String(value || '').replace(/\+/g, ' ').replace(/\s+/g, ' ').trim();
      const campaign = normalize(this.config.emailCampaign);
      const allowedIds = String(this.config.emailActivityIds || '').split(/[\s,;]+/).filter((id) => /^\d+$/.test(id));
      if (!campaign && !allowedIds.length) return null;
      const read = (name) => entries.find(([key]) => key.toLowerCase() === name)?.[1] || '';
      if (read('utm_source').toLowerCase() !== 'shopify_email' || read('utm_medium').toLowerCase() !== 'email') return null;
      const incomingCampaign = normalize(read('utm_campaign'));
      const activityValues = entries.filter(([key]) => key.toLowerCase() === 'se_activity_id').map(([, value]) => value.trim());
      const activityId = activityValues[0] || '';
      const campaignId = /_(\d+)$/.exec(incomingCampaign)?.[1] || '';
      if (activityValues.length && (!/^\d+$/.test(activityId) || !activityValues.every((value) => value === activityId) || (campaignId && campaignId !== activityId))) return null;
      const matchedId = allowedIds.includes(activityId || campaignId) ? activityId || campaignId : '';
      if (!matchedId && (!campaign || incomingCampaign !== campaign)) return null;
      const emailKey = matchedId ? `activity:${matchedId}` : campaign;
      let cart;
      try { cart = await fetchJson(`${rootUrl()}cart.js`); } catch { return null; }
      for (const item of Array.isArray(cart.discount_codes) ? cart.discount_codes : []) {
        const candidate = String(item.code || '').trim();
        if (!await this.matchesCode(candidate)) continue;
        const storageKey = `cz-md-campaign:${candidate.toUpperCase()}:${emailKey}:${this.config.endsAt || ''}`;
        try { if (sessionStorage.getItem(storageKey) === '1') return null; } catch {}
        return { type: 'email', code: candidate, storageKey };
      }
      return null;
    }

    findRecovery() {
      const fragments = new URLSearchParams(this.entryUrl.hash.slice(1));
      const values = fragments.getAll('cz-recover');
      if (!values.length) return null;
      this.invalidRecovery = true;
      if (values.length !== 1 || !values[0]) return null;
      try {
        const url = new URL(values[0]);
        const origins = new Set([location.origin]);
        if (this.config.storeUrl) origins.add(new URL(this.config.storeUrl).origin);
        if (this.config.shopDomain) origins.add(new URL(`https://${this.config.shopDomain}`).origin);
        if (url.protocol !== 'https:' || url.username || url.password || !origins.has(url.origin)) return null;
        if (!/^\/(?:\d+\/)?checkouts\/[^?#]+$/.test(url.pathname)) return null;
        this.invalidRecovery = false;
        return url;
      } catch { return null; }
    }

    recoveryDestination() {
      if (!this.recoveryUrl) return null;
      const url = new URL(this.recoveryUrl.href);
      if (!this.expired()) {
        url.searchParams.set('discount', this.code);
      }
      return url.href;
    }

    cleanUrl() {
      try {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()]) {
          if (key.toLowerCase() === this.config.param.toLowerCase()) url.searchParams.delete(key);
        }
        const fragments = new URLSearchParams(url.hash.slice(1));
        if (fragments.has('cz-recover')) {
          fragments.delete('cz-recover');
          url.hash = fragments.toString();
        }
        history.replaceState(history.state, '', url.href);
      } catch {}
    }

    async applyCode() {
      let result = { state: 'fallback', cart: null };
      try {
        let cart = await fetchJson(`${rootUrl()}cart.js`);
        const existing = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        let discount = existing.find((item) => sameCode(item.code, this.code));
        if (!discount) {
          if (this.expired()) return { state: 'expired', cart };
          const codes = [...new Set(existing.map((item) => item.code).filter(Boolean))];
          if (codes.length >= 5) return result;
          cart = await fetchJson(`${rootUrl()}cart/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: [...codes, this.code].join(',') }),
          });
          discount = (cart.discount_codes || []).find((item) => sameCode(item.code, this.code));
        }
        if (discount?.applicable === true) result = { state: 'applied', cart };
        else if (discount && cart.item_count === 0) result = { state: 'saved', cart };
        else result = { state: 'fallback', cart };
        if (discount) this.refreshCart(cart);
      } catch {}
      if (this.expired()) result.state = 'expired';
      publish('cz_mystery_applied', { code: this.code, state: result.state });
      return result;
    }

    async refreshCart(cart) {
      try {
        if (!cart?.item_count) return;
        const { DiscountUpdateEvent } = await import('@theme/events');
        document.dispatchEvent(new DiscountUpdateEvent(cart, `cz-mystery-${this.sectionId}`));
      } catch {}
    }

    open(trigger) {
      if (!this.isConnected || this.dialog.open || (!this.designMode && this.expired())) return;
      clearTimeout(this.closeTimer);
      this.closing = false;
      this.revealed = false;
      this.dialog.classList.remove('is-revealed', 'is-closing', 'is-intro', 'is-animated', 'has-status');
      this.applied.dataset.state = 'pending';
      this.appliedText.textContent = '';
      this.appliedSub.textContent = '';
      this.announcement.hidden = true;
      if (this.recoveryUrl) this.querySelector('[data-cz-md-cta]').textContent = this.config.recoveryButton;
      this.previousFocus = document.activeElement;
      try { this.dialog.showModal(); } catch { return; }
      if (!this.designMode && this.trigger?.storageKey) {
        try { sessionStorage.setItem(this.trigger.storageKey, '1'); } catch {}
      }
      document.documentElement.classList.add('cz-md-scroll-lock');
      this.startCountdown();
      if (!this.designMode) publish('cz_mystery_view', { code: this.code, trigger });
      if (reducedMotion()) { this.reveal('instant'); return; }
      this.dialog.classList.add('is-intro', 'is-animated');
      this.revealTimer = setTimeout(() => this.reveal('auto'), 1350);
    }

    reveal(method) {
      if (this.revealed || !this.dialog.open || this.closing) return;
      this.revealed = true;
      clearTimeout(this.revealTimer);
      this.dialog.classList.add('is-revealed');
      if (!this.designMode) publish('cz_mystery_reveal', { code: this.code, method });
      this.statusTimer = setTimeout(() => this.showStatus(), method === 'instant' ? 0 : 700);
    }

    async showStatus() {
      if (this.designMode) { this.setStatus('applied', this.config.appliedText, this.config.appliedNote); return; }
      this.slowTimer = setTimeout(() => this.setStatus('applying', this.config.applyingText), 150);
      const result = await this.applyPromise;
      clearTimeout(this.slowTimer);
      if (this.expired() || result?.state === 'expired') this.setStatus('expired', this.config.expiredText);
      else if (result?.state === 'recovery') this.setStatus('recovery', this.config.recoveryText, this.config.recoveryNote);
      else if (result?.state === 'invalid-recovery') this.setStatus('fallback', this.config.invalidRecovery);
      else if (result?.state === 'applied') this.setStatus('applied', this.config.appliedText, this.config.appliedNote);
      else if (result?.state === 'saved') this.setStatus('saved', this.config.savedText, this.config.savedNote);
      else this.setStatus('fallback', this.config.fallbackText, this.config.fallbackNote);
    }

    setStatus(state, text, sub = '') {
      if (!this.isConnected || !this.dialog.open || this.closing) return;
      this.applied.dataset.state = state;
      this.appliedText.textContent = text || '';
      this.appliedSub.textContent = sub;
      this.announcement.hidden = state === 'expired';
      this.dialog.classList.add('has-status');
    }

    timeLeft(ms) {
      const total = Math.floor(ms / 60000);
      if (total < 1) return this.config.lessThanMinute;
      const days = Math.floor(total / 1440);
      const hours = Math.floor(total % 1440 / 60);
      const minutes = total % 60;
      const unit = (number, name) => {
        try { return new Intl.NumberFormat(this.config.locale || 'en', { style: 'unit', unit: name, unitDisplay: 'long' }).format(number); }
        catch { return `${number}${{ day: 'd', hour: 'h', minute: 'm' }[name]}`; }
      };
      if (days) return [unit(days, 'day'), hours ? unit(hours, 'hour') : ''].filter(Boolean).join(' ');
      if (hours) return [unit(hours, 'hour'), minutes ? unit(minutes, 'minute') : ''].filter(Boolean).join(' ');
      return unit(minutes, 'minute');
    }

    startCountdown() {
      clearInterval(this.tick);
      this.countdown.hidden = !this.config.showCountdown || this.endsAt === null;
      if (this.endsAt === null || this.designMode && this.invalidEnd) return;
      const update = () => {
        if (this.expired()) {
          clearInterval(this.tick);
          if (!this.designMode) this.setStatus('expired', this.config.expiredText);
          this.countdown.textContent = this.config.expiredText;
          return;
        }
        this.countdown.textContent = this.config.countdownText.replace('[time]', this.timeLeft(this.endsAt - Date.now()));
      };
      update();
      if (!this.expired()) this.tick = setInterval(update, 1000);
    }

    close(method) {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      ['revealTimer', 'statusTimer', 'slowTimer'].forEach((key) => clearTimeout(this[key]));
      clearInterval(this.tick);
      if (!this.designMode) publish('cz_mystery_close', { code: this.code, method });
      const finish = () => {
        this.dialog.close();
        this.dialog.classList.remove('is-closing', 'is-intro', 'is-revealed', 'is-animated', 'has-status');
        this.unlockScroll();
        this.closing = false;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      };
      if (reducedMotion()) finish();
      else { this.dialog.classList.add('is-closing'); this.closeTimer = setTimeout(finish, 220); }
    }

    onClick = async (event) => {
      if (event.target === this.dialog) { this.close('backdrop'); return; }
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('[data-cz-md-close]')) { this.close('button'); return; }
      if (target.closest('[data-cz-md-tag]')) { this.reveal('tap'); return; }
      const cta = target.closest('[data-cz-md-cta]');
      if (!cta) return;
      event.preventDefault();
      if (cta.getAttribute('aria-busy') === 'true') return;
      if (this.designMode) { this.close('editor'); return; }
      publish('cz_mystery_cta', { code: this.code });
      cta.setAttribute('aria-busy', 'true');
      await this.applyPromise;
      cta.removeAttribute('aria-busy');
      if (!this.isConnected || !this.dialog.open || this.closing) return;
      this.close('cta');
      const recovery = this.recoveryDestination();
      if (recovery) location.assign(recovery);
      else if (!this.invalidRecovery && cta instanceof HTMLAnchorElement) location.assign(cta.href);
    };

    unlockScroll() {
      if (!document.querySelector('cz-mystery-discount dialog[open]')) document.documentElement.classList.remove('cz-md-scroll-lock');
    }

    setupEditor(signal) {
      const key = `cz-md-editor:${this.sectionId}`;
      const remember = (on) => { try { on ? sessionStorage.setItem(key, '1') : sessionStorage.removeItem(key); } catch {} };
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail?.sectionId !== this.sectionId) return;
        remember(true); this.open('editor');
      }, { signal });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail?.sectionId !== this.sectionId) return;
        remember(false); this.close('editor');
      }, { signal });
      const messages = [];
      if (!this.config.active) messages.push(this.config.editorDisabled);
      if (this.invalidEnd) messages.push(this.config.editorInvalidEnd);
      else if (this.expired()) messages.push(this.config.editorExpired);
      const note = this.querySelector('[data-cz-md-editor-note]');
      if (note && messages.length) { note.textContent = messages.join(' '); note.hidden = false; }
      try { if (sessionStorage.getItem(key) === '1') this.openTimer = setTimeout(() => this.open('editor'), 150); } catch {}
    }
  }
  customElements.define('cz-mystery-discount', CzMysteryDiscount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-sizing-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cz-sizing-page')) return;
  class CZSizingPage extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      const tablist = this.querySelector('[data-tabs]');
      if (!tablist || !this.tabs.length) return;
      tablist.hidden = false;
      tablist.setAttribute('role', 'tablist');
      this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      this.panels.forEach(panel => {
        const tab = this.tabs.find(item => item.dataset.tab === panel.dataset.panel);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.setAttribute('tabindex', '0');
        panel.querySelectorAll('[data-measure-button]').forEach(button => { button.disabled = false; });
        const first = panel.querySelector('[data-measure-button][aria-pressed="true"]') || panel.querySelector('[data-measure-button]');
        if (first) this.highlight(panel, first.dataset.measureButton);
      });
      this.querySelectorAll('[data-interaction-hint], [data-units]').forEach(node => { node.hidden = false; });
      this.setAttribute('data-ready', '');
      this.selectTab(this.activeTab || 'tops');
      let stored;
      try { stored = localStorage.getItem('cz_sizing_page_unit'); } catch {}
      this.setUnit(stored === 'imperial' ? 'imperial' : 'metric', false);
      this.addEventListener('click', event => {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;
        if (target.dataset.tab) this.selectTab(target.dataset.tab);
        if (target.dataset.unit) this.setUnit(target.dataset.unit, true);
        if (target.dataset.measureButton) this.highlight(target.closest('[data-panel]'), target.dataset.measureButton);
      }, { signal });
      tablist.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.selectTab(this.tabs[next].dataset.tab);
        this.tabs[next].focus();
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    selectTab(name) {
      if (!this.tabs.some(tab => tab.dataset.tab === name)) return;
      this.activeTab = name;
      this.tabs.forEach(tab => {
        const selected = tab.dataset.tab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== name; });
    }
    highlight(panel, name) {
      if (!panel) return;
      panel.querySelectorAll('[data-measure-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.measureButton === name)));
      panel.querySelectorAll('[data-measure]').forEach(group => group.classList.toggle('is-active', group.dataset.measure === name));
    }
    setUnit(unit, remember) {
      const imperial = unit === 'imperial';
      this.querySelectorAll('[data-unit]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.unit === 'imperial') === imperial)));
      let formatter;
      try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }); } catch { formatter = new Intl.NumberFormat('en', { maximumFractionDigits: 2 }); }
      this.querySelectorAll('[data-cm]').forEach(node => {
        const cm = Number(node.dataset.cm);
        if (Number.isFinite(cm)) node.textContent = formatter.format(imperial ? cm / 2.54 : cm) + (imperial ? ' in' : ' cm');
      });
      if (remember) { try { localStorage.setItem('cz_sizing_page_unit', imperial ? 'imperial' : 'metric'); } catch {} }
    }
  }
  customElements.define('cz-sizing-page', CZSizingPage);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeans-fit-filter"] && !Shopify.designMode) return;
  try {
    
  class JeansFitFilter extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.initialFrame);
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.list = this.querySelector('.jff__list');
      this.navigation = this.querySelector('.jff__nav');
      this.scrollButtons = this.querySelectorAll('[data-jff-scroll]');
      this.list?.addEventListener('scroll', () => this.updateScrollControls(), { passive: true, signal });
      for (const button of this.scrollButtons) {
        button.addEventListener('click', () => {
          if (!this.list || button.getAttribute('aria-disabled') === 'true') return;
          const direction = button.dataset.jffScroll === 'left' ? -1 : 1;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollBy({ left: direction * Math.max(96, this.list.clientWidth * .75), behavior: reduceMotion ? 'instant' : 'smooth' });
        }, { signal });
        button.addEventListener('blur', () => this.updateScrollControls(), { signal });
      }
      if (this.list && typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(() => this.updateScrollControls());
        this.resizeObserver.observe(this.list);
      } else {
        window.addEventListener('resize', () => this.updateScrollControls(), { signal });
      }
      this.updateLinks();
      this.initialFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const list = this.list;
        const selected = this.querySelector('[aria-current="page"]');
        if (list && selected) {
          const bounds = list.getBoundingClientRect();
          const card = selected.getBoundingClientRect();
          if (card.left < bounds.left) list.scrollLeft += card.left - bounds.left;
          else if (card.right > bounds.right) list.scrollLeft += card.right - bounds.right;
        }
        this.updateScrollControls();
      });
      window.addEventListener('popstate', () => this.updateLinks(), { signal: this.controller.signal });
      this.addEventListener('pointerdown', () => this.updateLinks(), { signal: this.controller.signal });
      this.addEventListener('focusin', () => this.updateLinks(), { signal: this.controller.signal });
      this.addEventListener('click', () => this.updateLinks(), { signal: this.controller.signal, capture: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.initialFrame);
    }
    updateScrollControls() {
      if (!this.list || !this.navigation) return;
      const first = this.list.firstElementChild?.getBoundingClientRect();
      const last = this.list.lastElementChild?.getBoundingClientRect();
      const bounds = this.list.getBoundingClientRect();
      const overflow = this.list.scrollWidth > this.list.clientWidth + 3;
      const available = {
        left: Boolean(overflow && first && last && Math.min(first.left, last.left) < bounds.left - 3),
        right: Boolean(overflow && first && last && Math.max(first.right, last.right) > bounds.right + 3)
      };
      this.navigation.dataset.scrollLeft = String(available.left);
      this.navigation.dataset.scrollRight = String(available.right);
      for (const button of this.scrollButtons) {
        const canScroll = available[button.dataset.jffScroll];
        button.hidden = !canScroll && document.activeElement !== button;
        button.setAttribute('aria-disabled', String(!canScroll));
        button.tabIndex = canScroll ? 0 : -1;
      }
    }
    updateLinks() {
      const current = new URL(window.location.href);
      const ownedTags = new Set((this.dataset.ownedTags || '').split('|').filter(Boolean));
      const isOwnedTag = value => ownedTags.has(value.trim().toLowerCase());
      for (const link of this.querySelectorAll('[data-jff-link]')) {
        const destination = new URL(link.getAttribute('href'), window.location.origin);
        destination.search = '';
        for (const [key, value] of current.searchParams) {
          if (key === 'page' || key === 'section_id' || key === 'sections') continue;
          if (key === 'filter.p.tag') {
            const unrelated = value.split(',').filter(tag => !isOwnedTag(tag));
            if (unrelated.length) destination.searchParams.append(key, unrelated.join(','));
          } else {
            destination.searchParams.append(key, value);
          }
        }
        link.href = destination.pathname + destination.search;
      }
    }
  }
  if (!customElements.get('jeans-fit-filter')) customElements.define('jeans-fit-filter', JeansFitFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rush-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rush-cart-banner')) {
    customElements.define('rush-cart-banner', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.sequence = 0;
        this.code = (this.dataset.code || '').trim().toUpperCase();
        if (this.dataset.editor === 'true') {
          this.hidden = false;
          return;
        }
        if (this.dataset.active !== 'true' || !this.code) return;

        document.addEventListener('discount:update', event => {
          const cart = event.detail?.resource;
          if (Array.isArray(cart?.discount_codes) && typeof cart.item_count === 'number') {
            this.sequence++;
            this.showFor(cart);
          } else this.refresh();
        }, { signal });
        document.addEventListener('cart:update', () => this.refresh(), { signal });
        window.addEventListener('pageshow', () => this.refresh(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, { signal });
        this.interval = window.setInterval(() => {
          if (!document.hidden) this.refresh();
        }, 30000);
        this.refresh();
      }

      disconnectedCallback() {
        this.sequence++;
        this.controller?.abort();
        window.clearInterval(this.interval);
      }

      async refresh() {
        const sequence = ++this.sequence;
        const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
        try {
          const response = await fetch(`${root}/cart.js`, {
            credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: this.controller.signal,
          });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (this.isConnected && sequence === this.sequence) this.showFor(cart);
        } catch {
          if (this.isConnected && sequence === this.sequence) this.hidden = true;
        }
      }

      showFor(cart) {
        const applicable = Array.isArray(cart?.discount_codes) && cart.discount_codes.some(discount =>
          String(discount.code || '').trim().toUpperCase() === this.code && discount.applicable === true
        );
        if (!applicable || !(Number(cart.item_count) > 0)) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
